module.exports = __webpack_public_path__ + "img/date.c1ade4a1.svg";